import MerchantNames from './MerchantNames';

export default MerchantNames;
